import { standardDeleteApi } from "../../api/standard/standardDeleteApi"

type PayloadShape = Parameters<typeof standardDeleteApi>[0]

export async function standardDeleteService(payload: PayloadShape, token: string) {
	return await standardDeleteApi(payload, token)
}
